const getIntegrationAuthorizationReturnPath = (state: string | null) =>
  state === 'integrations' ? '/settings/integrations' : '/onboarding';

export default getIntegrationAuthorizationReturnPath;
